import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { ButtonContainer } from '../../../form';
import { IDataPrivacyMessageStepProps } from './types';
import useStepper from '../../../stepper/useStepper';

const DataPrivacyMessageStep: React.FC<IDataPrivacyMessageStepProps> = ({
  content,
}) => {
  const history = useHistory();
  const { showNext, cancelPath } = useStepper();

  return (
    <div>
      <div
        className="ck-content"
        dangerouslySetInnerHTML={{ __html: content }}
      />
      <ButtonContainer>
        <Button variant="primary" type="button" onClick={showNext}>
          I Agree
        </Button>
        <Button
          variant="secondary"
          type="button"
          onClick={() => history.replace(cancelPath)}
        >
          Cancel
        </Button>
      </ButtonContainer>
    </div>
  );
};

export default DataPrivacyMessageStep;
